import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getBackgroundColorWidthConfig, getBackgroundWithRowType } from '../helper';

var TriserialBlock = function TriserialBlock(props) {
  var _onClick = props.onClick,
      rowType = props.rowType;
  var config = props.config;
  var bgColor = getBackgroundColorWidthConfig(config.bgColor, rowType);
  var background = getBackgroundWithRowType(rowType, bgColor, config);
  return _jsxs("div", Object.assign({
    style: background,
    className: (rowType || 'imageBlock') + " lego_rowsBlock3",
    onClick: function onClick() {
      return _onClick({
        link: config.link,
        deeplink: config.deepLink
      });
    }
  }, {
    children: [rowType !== 'bgBlock' && _jsx("div", Object.assign({
      className: "block3ImgContent"
    }, {
      children: _jsx("img", {
        src: config.imgSrc
      })
    })), _jsxs("div", Object.assign({
      className: "block3TextContent " + config.textModel
    }, {
      children: [_jsxs("div", Object.assign({
        className: "block3text"
      }, {
        children: [_jsx("p", Object.assign({
          className: "block3Title1"
        }, {
          children: config.title1
        })), _jsx("p", Object.assign({
          className: "block3Title2"
        }, {
          children: config.title2
        }))]
      })), _jsxs("div", Object.assign({
        className: "enterNow"
      }, {
        children: [_jsx("span", {
          children: config.enterText || '马上进入'
        }), _jsx("span", Object.assign({
          className: "rightArraw"
        }, {
          children: '>'
        }))]
      }))]
    }))]
  }));
};

TriserialBlock.displayName = 'TriserialBlock';
TriserialBlock.defaultProps = {
  config: {}
};
export default TriserialBlock;